import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Icon, Modal } from 'antd';

const AlertTitle = ({ type, title }) => {
  if (!title) {
    return null;
  }
  return (
    <div className={`bhp-alert-${type} bhp-alert-title`}>
      {title}
    </div>
  );
};
AlertTitle.propTypes = {
  type: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

const AlertSummary = ({ summary }) => {
  if (!summary) {
    return null;
  }
  return (
    <div>
      {summary}
    </div>
  );
};
AlertSummary.propTypes = {
  summary: PropTypes.string.isRequired
};

const AlertItems = ({ items }) => {
  if (!items || items.length === 0) {
    return null;
  }

  const listItems = items.map(message => (
    <li key={message}>
      <Icon type="arrow-right" />
      <span>
        {message}
      </span>
    </li>
  ));
  return (
    <ul>
      {listItems}
    </ul>
  );
};
AlertItems.propTypes = {
  items: PropTypes.array.isRequired
};

class AlertMessage extends React.Component {
  static propTypes = {
    type: PropTypes.string,
    size: PropTypes.string,
    title: PropTypes.string,
    summary: PropTypes.string,
    messageList: PropTypes.array,
    popUp: PropTypes.bool,
    onPopUpOk: PropTypes.func,
    onClose: PropTypes.func
  };

  static defaultProps = {
    type: 'warning',
    size: 'default',
    title: null,
    summary: null,
    messageList: [],
    popUp: false,
    onPopUpOk() {
    },
    onClose() {
    }
  };

  componentDidMount() {
    const {
      popUp, type, title, summary, messageList
    } = this.props;
    this.displayPopupMessage(popUp, type, title, summary, messageList);
  }

  getAlertMessage = (type, size, title, summary, messageList) => (
    <div>
      {size === 'small' ? <AlertTitle type={type} title={title} /> : null}
      <AlertSummary summary={summary} />
      <AlertItems items={messageList} />
    </div>
  );

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      popUp, type, title, summary, messageList
    } = nextProps;
    this.displayPopupMessage(popUp, type, title, summary, messageList);
  }

  displayPopupMessage(popUp, type, title, summary, messageList) {
    const { onPopUpOk } = this.props;
    if (popUp && messageList.length > 0) {
      const alertMessage = this.getAlertMessage(type, 'default', title, summary, messageList);
      Modal.error({
        className: 'bhp-alert-message',
        title,
        content: alertMessage,
        onOk() {
          onPopUpOk();
        }
      });
    }
  }

  render() {
    const { messageList, onClose, popUp } = this.props;
    if (popUp || messageList.length === 0) {
      return null;
    }

    const {
      type, size, title, summary
    } = this.props;
    const alertMessage = this.getAlertMessage(type, size, title, summary, messageList);

    if (size === 'small') {
      return (<Alert className="bhp-alert-message" type={type} message={alertMessage} showIcon onClose={onClose} />);
    }

    return (<Alert className="bhp-alert-message" type={type} message={title} description={alertMessage} showIcon onClose={onClose} />);
  }
}

export default AlertMessage;
